export default __webpack_public_path__ + "static/media/NAmerica.f2caab34.png";